import React, { createContext, useContext, useMemo, useState } from "react";

/**
 * Analysis Sync Zoom — share a price window across multiple chart components
 * on the Analysis page (SymbolChart's time-series Y-range ↔ GEXChart's strike X-range).
 *
 * Both charts opt in by reading {syncEnabled, priceWindow, setPriceWindow}.
 * SymbolChart publishes its visible price range whenever the user zooms,
 * GEXChart consumes the same window to clamp its strike axis.
 */
const Ctx = createContext({
  syncEnabled: false,
  setSyncEnabled: () => {},
  priceWindow: null,
  setPriceWindow: () => {},
});

export function AnalysisSyncProvider({ children }) {
  const [syncEnabled, setSyncEnabled] = useState(false);
  const [priceWindow, setPriceWindow] = useState(null);
  const value = useMemo(
    () => ({ syncEnabled, setSyncEnabled, priceWindow, setPriceWindow }),
    [syncEnabled, priceWindow],
  );
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useAnalysisSync() {
  return useContext(Ctx);
}
